<template>
  <div class="mv-cliprow" :class="{ 'is-sel': selected }">
    <span class="mono" style="flex: none; width: 16px; text-align: right; font-size: 10px; color: var(--text-ph)">{{ String(position).padStart(2, "0") }}</span>
    <img
      :src="$store.state.getThumbUrl(value.assetID, asset && asset.thumbnail)"
      loading="lazy"
      alt=""
      style="flex: none; width: 44px; height: 25px; object-fit: cover; border-radius: 4px; background: var(--bg); cursor: pointer"
      @click="play()" />
    <div style="flex: 1 1 40%; min-width: 0; display: flex; flex-direction: column; gap: 2px; cursor: pointer" @click="play()">
      <span ellipsis style="font-size: 12px; font-weight: 600; color: var(--text)">{{ value.name }}</span>
      <span class="mono" ellipsis style="font-size: 9.5px; color: var(--text-faint)">{{ rangeLabel }}</span>
    </div>
    <input
      class="mv-note"
      :class="{ 'has-text': !!note }"
      placeholder="Comment"
      :value="note"
      @input="note = $event.target.value"
      @focus="editing = true"
      @blur="editing = false"
      @change="saveNote()" />
    <button type="button" class="mv-cliprow-del" title="Remove from cart" aria-label="Remove from cart" @click="remove()">✕</button>
  </div>
</template>

<script>
import { assetState } from "@/scripts/assetStatus";
import { WIRE_UNSET, displayTc, framesToTc } from "@/scripts/timecode.js";
import { clipFrames } from "@/scripts/cartTotals.js";

export default {
  props: {
    value: {},
    position: { type: Number, default: 1 },
  },
  data() {
    // a local draft, so a live update of the cart does not overwrite a comment being typed
    return { note: this.value.note || "", editing: false };
  },
  computed: {
    /** The clip the player has loaded. */
    selected() {
      return this.$store.state.currentSubclip.id === this.value.id;
    },
    asset() {
      return this.$store.state.getClipById(this.value.assetID);
    },
    hasIn() {
      return this.value.tcIn !== WIRE_UNSET;
    },
    hasOut() {
      return this.value.tcOut !== WIRE_UNSET;
    },
    rangeLabel() {
      if (this.hasIn && this.hasOut) return displayTc(this.value.tcIn) + " – " + displayTc(this.value.tcOut);
      if (this.hasIn) return displayTc(this.value.tcIn) + " – End";
      if (this.hasOut) return "Start – " + displayTc(this.value.tcOut);
      const frames = clipFrames(this.value, this.$store.state.clipLookups());
      return frames == null ? "Full" : "Full · " + framesToTc(frames);
    },
    // Whole and In-only clips need the asset's length; asking again when its status changes means a
    // clip of an asset that turns ready gets it. The asset loads after mount, hence no mount-time call.
    probeKey() {
      return !this.hasOut && this.asset ? this.asset.id + ":" + assetState(this.asset).key : "";
    },
  },
  watch: {
    probeKey: {
      immediate: true,
      handler(key) {
        if (key) this.$store.state.requestDuration(this.asset);
      },
    },
    "value.note"(note) {
      if (!this.editing) this.note = note || "";
    },
  },
  methods: {
    play() {
      this.$store.state.playSubclip(this.value);
    },
    saveNote() {
      if (this.note === (this.value.note || "")) return;
      this.$store.state.updateSubclip({ ...this.value, note: this.note });
    },
    remove() {
      this.$store.state.showConfirmDialog('Remove "' + this.value.name + '" from cart?', () => this.$store.state.deleteSubclip(this.value));
    },
  },
};
</script>
